<template>
    <div>
        <div class="container lnb d_container">
            <div class="contents_wrap">
                <div class="contents list-container">
                    <div class="title">프리미엄 회원 추가</div>
                    <member-write-component :memberType="'createPremium'"></member-write-component>
                    <div class="pa15 text-center btn_wrap">
                        <el-button type="save" @click="save">저장</el-button>
                        <el-button type="cancel" @click="backEvent()" :disabled="disableBtn">목록</el-button>

                    </div>

                </div>

                <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import MemberWriteComponent from "@/components/member/MemberWriteComponent";

export default {
    name: "MemberPremiumCreate",
    mixins: [],
    components: {
        MemberWriteComponent,
    },
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            memberKey: Number(this.$route.params.m_idx),
        }
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        save() {
            EventBus.$emit('writeMember')
        },
        backEvent() {
            this.$router.back();
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
